import decode from 'jwt-decode';
import { useState } from 'react';

interface Response {
  data:
    | {
        user: { name: string; phoneNumber: string; email?: string };
        token: string;
      }
    | undefined;
  error?: boolean;
  loading: boolean;
  isLoggedIn: boolean;
}

function getToken(encodedToken: string) {
  // token ""easday""
  const bearer = 'Bearer ';
  const cleaned = encodedToken.startsWith(bearer)
    ? encodedToken.substring(bearer.length)
    : encodedToken; // substring because authorization is always "Bearer xyz... "
  let parsed: { claims: any } = decode(cleaned);

  // Patch changes being made to tokens from our identity provider where claims property is omitted.
  // TODO: Should be removed when Identity Provider is same between dev/uat/prod environments
  if (parsed?.claims && typeof parsed?.claims === typeof '') {
    const parsedClaims = JSON.parse(parsed.claims);
    parsed = { parsed, ...parsedClaims };
  }

  return parsed;
}

type UseLogin = [(phoneNumber: string) => void, Response];

const getUserFromToken = (token: string) => {
  const decoded = getToken(token);
  const name = decoded['customer.actingName'];
  const email = decoded['email'];
  return { name, email };
};

export const useLogin = (): UseLogin => {
  const [response, setResponse] = useState<Response>({
    data: undefined,
    error: undefined,
    loading: false,
    isLoggedIn: false,
  });

  async function getPkiSim(phoneNumber: string) {
    setResponse({
      data: undefined,
      error: undefined,
      loading: true,
      isLoggedIn: false,
    });
    const response = await fetch(
      `https://mobile.landsbankinn.is/services/authentication/pkisim`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          phoneNumber,
        }),
      },
    );
    if (response.ok) {
      const token = await response.json();
      setResponse({
        data: {
          token,
          user: {
            ...getUserFromToken(token),
            phoneNumber,
          },
        },
        error: undefined,
        loading: false,
        isLoggedIn: true,
      });
      return;
    }
    setResponse({
      data: undefined,
      error: true,
      loading: false,
      isLoggedIn: false,
    });
  }
  return [getPkiSim, response];
};
